import { createAction } from '@reduxjs/toolkit';
import type { EngagementPhase } from './definitions';
import { ACTION_ATTACH_FILES, ACTION_DETACH_FILES } from './actionTypes';

export const changeEngagementPhase = createAction<{ phase: EngagementPhase }>('TWILIO_CHANGE_ENGAGEMENT_PHASE');
export const addNotification = createAction<any>('TWILIO_ADD_NOTIFICATION');

// File attachment actions for Twilio chat input
export const attachFiles = createAction<{ filesToAttach: File[] }>(ACTION_ATTACH_FILES);
export const detachFiles = createAction<{ filesToDetach: File[] }>(ACTION_DETACH_FILES);

